var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "h-15 w-15"
  }, [_c('div', {
    staticClass: "pie relative rounded-full",
    class: _vm.color + ' bg-opacity-50',
    style: '--p:' + _vm.p + '; --b:2px;--c:' + _vm.borderColor + ';'
  }, [_c('span', {
    staticClass: "font-normal text-lg"
  }, [_vm._v(_vm._s(_vm.p))])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }